// Module-level cache: mittausProjektiId → full project object (with kohteet)
// Blocks write here after loading from API; PDF renderers read synchronously.
const cache = {};
const subscribers = {};

export function mittausCacheSet(id, projektData) {
  cache[id] = projektData;
  if (subscribers[id]) subscribers[id].forEach(fn => fn(projektData));
}

export function mittausCacheGet(id) {
  return cache[id] ?? null;
}

// Returns an unsubscribe function. Callback fires synchronously inside mittausCacheSet.
export function mittausCacheSubscribe(id, callback) {
  if (!id) return () => {};
  if (!subscribers[id]) subscribers[id] = new Set();
  subscribers[id].add(callback);
  return () => { if (subscribers[id]) subscribers[id].delete(callback); };
}

// Nayte-level patch cache: nayteId → partial field map (e.g. karb stats from PeitepaksuusBlock)
const naytteetPatch = {};
const naytteetSubs = {};

export function naytteetCacheSet(nayteId, fields) {
  naytteetPatch[nayteId] = { ...(naytteetPatch[nayteId] ?? {}), ...fields };
  (naytteetSubs[nayteId] ?? new Set()).forEach(fn => fn(naytteetPatch[nayteId]));
}

export function naytteetCacheSubscribe(nayteId, callback) {
  if (!nayteId) return () => {};
  if (!naytteetSubs[nayteId]) naytteetSubs[nayteId] = new Set();
  naytteetSubs[nayteId].add(callback);
  if (naytteetPatch[nayteId]) callback(naytteetPatch[nayteId]);
  return () => { if (naytteetSubs[nayteId]) naytteetSubs[nayteId].delete(callback); };
}

// Naytteet list cache: projektiId → full naytteet array (kept in sync by PoranayteBlock)
const naytteetListCache = {};
export function naytteetListSet(projektiId, list) { if (projektiId) naytteetListCache[projektiId] = list; }
export function naytteetListGet(projektiId) { return naytteetListCache[projektiId] ?? null; }

// Nayte tunnus change broadcast: fired by PoranayteBlock when nayte_tunnus is renamed
const nayteTunnusSubs = new Set();
export function subscribeNayteTunnus(cb) {
  nayteTunnusSubs.add(cb);
  return () => nayteTunnusSubs.delete(cb);
}
export function broadcastNayteTunnus(nayteId, newTunnus) {
  nayteTunnusSubs.forEach(cb => cb(nayteId, newTunnus));
}

// New-nayte notification: fired when another block creates a nayte in a poranäyte project
const naytteeAddedSubs = {};

export function naytteetCacheAddNotify(projektiId, nayte) {
  (naytteeAddedSubs[projektiId] ?? new Set()).forEach(fn => fn(nayte));
}

export function naytteetCacheAddSubscribe(projektiId, callback) {
  if (!projektiId) return () => {};
  if (!naytteeAddedSubs[projektiId]) naytteeAddedSubs[projektiId] = new Set();
  naytteeAddedSubs[projektiId].add(callback);
  return () => { if (naytteeAddedSubs[projektiId]) naytteeAddedSubs[projektiId].delete(callback); };
}
